import { getReverseProposalBrands as getReverseProposalBrandsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetReverseProposalBrandsServiceRequest,
  GetReverseProposalBrandsServiceResponse,
} from './get-reverse-proposal-brands.dto';
import {
  GetReverseProposalBrandsServiceRequestSchema,
  GetReverseProposalBrandsServiceResponseSchema,
} from './get-reverse-proposal-brands.dto';

export const getReverseProposalBrandsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetReverseProposalBrandsServiceRequestSchema),
    async (
      request: GetReverseProposalBrandsServiceRequest,
    ): Promise<GetReverseProposalBrandsServiceResponse> => {
      const apiResponse = await getReverseProposalBrandsApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '브랜드 목록 조회에 실패했습니다.');
      }

      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      return {
        list: apiResponse.data.list,
        total: apiResponse.link?.total ?? 0,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };
    },
    validateServiceResponse(GetReverseProposalBrandsServiceResponseSchema),
  ),
);
